export const getPeoStaffLabel = (peoDisplayName: string | null | undefined) => {
  if (!peoDisplayName) {
    return 'Staff';
  }

  return `${peoDisplayName}'s Staff`;
};
